












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class InputSimple extends Vue {
  @Prop({ default: '' })
  placeholder!: string

  @Prop()
  value!: string

  @Prop()
  size?: string

  @Prop({ default: null })
  labelcolor?: null | string

  @Prop({ default: false })
  enableEnterSubmit?: boolean

  get classObject(): { [key: string]: boolean } {
    const { size } = this
    return {
      'input-base__main__size-default': !size,
      'input-base__main__size-block': size === 'block',
    }
  }

  private updateValue(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value
    this.$emit('input', inputValue, event)
  }

  private enterSubmit(event: KeyboardEvent) {
    if (this.enableEnterSubmit && event.code === 'Enter') {
      this.$emit('enter-event')
    }
  }
}
